<div>
  <app-trial-code-modal
    *ngIf="modalConfig?.showTrialCode"
    [order]="order"
    [titleKey]="'eos-tv-shop-ii.title.trial-activation'"
    [descriptionKey]="'eos-tv-shop-ii.text.trial-activation'"
    [config]="modalConfig"
    [runningTrials]="runningTrials"
  ></app-trial-code-modal>

  <app-find-trial-code-modal
    *ngIf="modalConfig?.showFindTrialCode"
    [config]="modalConfig"
  ></app-find-trial-code-modal>

  <app-trial-success-modal
    *ngIf="modalConfig?.showTrialSuccess && successOmapiId"
    [omapiId]="successOmapiId"
    [trialOmapiId]="trialOmapiId"
    [config]="modalConfig"
  ></app-trial-success-modal>

  <app-conditions-modal
    *ngIf="modalConfig?.showOrderConditions"
    [config]="modalConfig"
    (emitCloseConditions)="closeConditions()"
    [titleKey]="'eos-tv-shop-ii.title.conditions-modal'"
    [descriptionKey]="'eos-tv-shop-ii.text.trial-conditions-modal' | translate"
    [closeButtonTextKey]="'eos-tv-shop-ii.btn.conditions-modal-close'"
  ></app-conditions-modal>

  <app-trial-comparison
    *ngIf="modalConfig?.showTrialComparison"
    [config]="modalConfig"
    [trials]="trialsToCompare"
  ></app-trial-comparison>

  <app-trial-attempts-reached-modal
    *ngIf="modalConfig?.showTrialAttemptsReached"
    [config]="modalConfig"
  >
  </app-trial-attempts-reached-modal>


  <app-trial-activation-pending-modal
    [config]="modalConfig"
    *ngIf="modalConfig?.showTrialPending"
    [error]="error"
    [trialOmapiId]="trialOmapiId"
  ></app-trial-activation-pending-modal>
</div>
